import axiosInstance from "../../../api/axiosConfig";
import { LoginFormValues } from "./login-page.type";

export const login = (data: LoginFormValues) => {
  return axiosInstance.post("/auth/login", data);
};

export const logout = (refreshToken: string | null) => {
  if (!refreshToken) {
    return;
  }
  return axiosInstance.post("/auth/logout", {
    refreshToken,
  });
};
